import { ListOptionsFormController } from '@shared/list-options/list-options-form.controller';

import { EMSP_BO_TARIFF_LIST_COLUMN_LABEL_I18N_KEY } from '../emsp-bo-tariff-list/emsp-bo-tariff-list.config';
import { useEmspBoTariffListContext } from '../emsp-bo-tariff.context';

export const EmspBoTariffListOptionsController = (): React.JSX.Element => {
  const { columnOptions, setColumnOptions } = useEmspBoTariffListContext();

  return (
    <ListOptionsFormController
      columnOptions={columnOptions}
      columnLabelMap={EMSP_BO_TARIFF_LIST_COLUMN_LABEL_I18N_KEY}
      onChange={setColumnOptions}
    />
  );
};
